document.addEventListener('DOMContentLoaded', function() {
  const extraOptionsContainer = document.querySelector('product-extra-options');
  if (!extraOptionsContainer) return;

  const cards = extraOptionsContainer.querySelectorAll('.wt-product__extra-option-card');
  if (cards.length === 0) return;

  // Get variant data from the page
  function getVariantData() {
    const variantOptions = document.querySelector('variant-options');
    if (!variantOptions) return [];
    const jsonEl = variantOptions.querySelector('[type="application/json"]');
    if (!jsonEl) return [];
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return [];
    }
  }

  // Get current variant ID from the form
  function getCurrentVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input ? parseInt(input.value) : null;
  }

  // Get variant price from variant data
  function getVariantPrice(variantId) {
    const variants = getVariantData();
    const variant = variants.find(v => v.id === variantId);
    return variant ? variant.price : null;
  }

  let basePrice = getVariantPrice(getCurrentVariantId()) || 0;

  function getSelectedTotal() {
    const selectedCard = document.querySelector('.wt-product__extra-option-card.is-selected');
    if (!selectedCard) return 0;

    const radio = selectedCard.querySelector('input[type="radio"]');
    if (radio && radio.dataset.price) {
      return parseInt(radio.dataset.price) || 0;
    }
    return 0;
  }

  function formatPrice(cents) {
    const price = cents / 100;
    return price.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  }

  function updateDisplayedPrice() {
    const total = basePrice + getSelectedTotal();
    document.querySelectorAll('.wt-product__price__final').forEach(el => {
      el.textContent = formatPrice(total);
    });
  }

  updateDisplayedPrice();

  cards.forEach(card => {
    card.addEventListener('click', function(e) {
      e.preventDefault();

      const wasSelected = this.classList.contains('is-selected');
      const radio = this.querySelector('input[type="radio"]');

      if (wasSelected) {
        // Deselect if clicking the same item
        this.classList.remove('is-selected');
        if (radio) {
          radio.checked = false;
        }
      } else {
        // Deselect all others and select this one
        cards.forEach(otherCard => {
          otherCard.classList.remove('is-selected');
        });
        this.classList.add('is-selected');
        if (radio) {
          radio.checked = true;
        }
      }

      // Update price
      updateDisplayedPrice();
    });
  });

  // Listen for variant change - get price from variant JSON data
  document.addEventListener('variantChangeEnd', function(event) {
    // Reset all selections
    cards.forEach(card => {
      card.classList.remove('is-selected');
      const radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = false;
    });

    // Re-select the default accessory if one exists
    const defaultVariantId = extraOptionsContainer.dataset.defaultVariantId;
    if (defaultVariantId) {
      cards.forEach(card => {
        const radio = card.querySelector('input[type="radio"]');
        if (radio && radio.dataset.variantId === defaultVariantId) {
          card.classList.add('is-selected');
          radio.checked = true;
        }
      });
    }

    // Get new base price from the variant in event detail
    if (event.detail && typeof event.detail.price === 'number') {
      basePrice = event.detail.price;
    } else {
      // Fallback: get price from variant JSON using the variant ID
      const variantId = event.detail?.id || getCurrentVariantId();
      if (variantId) {
        const price = getVariantPrice(variantId);
        if (price !== null) {
          basePrice = price;
        }
      }
    }

    updateDisplayedPrice();
  });
});

// Keep the custom element for cart functionality
class ProductExtraOptions extends HTMLElement {
  getSelectedExtras(quantity = 1) {
    const selected = [];
    const checkedRadio = this.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      selected.push({
        id: parseInt(checkedRadio.dataset.variantId),
        quantity: quantity
      });
    }
    return selected;
  }

  hasSelectedExtras() {
    return this.querySelector('input[type="radio"]:checked') !== null;
  }
}

customElements.define('product-extra-options', ProductExtraOptions);

// Cart form handling - intercept submit button click instead of form submit
document.addEventListener('DOMContentLoaded', function() {
  const productFormEl = document.querySelector('product-form');
  if (!productFormEl) return;

  const form = productFormEl.querySelector('form');
  if (!form) return;

  const submitButton = productFormEl.querySelector('[type="submit"]');
  if (!submitButton) return;

  submitButton.addEventListener('click', async function(evt) {
    const extraOptionsEl = document.querySelector('product-extra-options');
    if (!extraOptionsEl || !extraOptionsEl.hasSelectedExtras()) {
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    const loader = productFormEl.querySelector('.loading-overlay__spinner');
    const cart = document.querySelector('cart-drawer');

    if (submitButton.getAttribute('aria-disabled') === 'true') return;
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    if (loader) loader.classList.remove('hidden');

    try {
      const formData = new FormData(form);
      const mainVariantId = parseInt(formData.get('id'));
      const mainQuantity = parseInt(formData.get('quantity')) || 1;

      const groupId = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

      const properties = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[') && value) {
          const propName = key.slice(11, -1);
          properties[propName] = value;
        }
      }
      properties._cart_group = groupId;

      const items = [{ id: mainVariantId, quantity: mainQuantity, properties }];

      const selectedExtras = extraOptionsEl.getSelectedExtras(mainQuantity);
      selectedExtras.forEach(extra => {
        items.push({
          ...extra,
          properties: { _cart_group: groupId, _is_child: 'true' }
        });
      });

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || 'Error adding to cart');
      }

      if (cart) {
        const sectionsToRender = cart.getSectionsToRender();
        const sectionNames = sectionsToRender.map((section) => section.section || section.id);
        const uniqueSectionNames = [...new Set(sectionNames)];

        const sectionsFormData = new FormData();
        sectionsFormData.append('sections', uniqueSectionNames);
        sectionsFormData.append('sections_url', window.location.pathname);

        const sectionsResponse = await fetch(
          window.Shopify.routes.root + 'cart/update.js?' + new URLSearchParams(sectionsFormData).toString()
        );
        const sectionsResult = await sectionsResponse.json();

        const mappedSections = {};
        sectionsToRender.forEach((section) => {
          const sectionKey = section.section || section.id;
          mappedSections[section.id] = sectionsResult.sections[sectionKey];
        });
        sectionsResult.sections = mappedSections;

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainVariantId,
            cartData: sectionsResult,
          });
        }

        cart.renderContents(sectionsResult, true);

        setTimeout(() => {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
          if (loader) loader.classList.add('hidden');
        }, 500);
      } else {
        window.location = window.routes.cart_url;
      }

    } catch (error) {
      console.error('Error adding products to cart:', error);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          message: error.message
        });
      }

      const errorWrapper = productFormEl.querySelector('.product-form__error-message-wrapper');
      const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
      if (errorWrapper && errorMessage) {
        errorWrapper.removeAttribute('hidden');
        errorMessage.textContent = error.message;
      }

      submitButton.removeAttribute('aria-disabled');
      submitButton.classList.remove('loading');
      if (loader) loader.classList.add('hidden');
    }
  }, true);
});